import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../../__root";

export const usersPasswordNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/users/password/new",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "ForgotPasswordPage" */ "@circle-react/components/OnboardingPage/ForgotPasswordPage"
      ),
    "ForgotPasswordPage",
  ),
});
